import { OpstaPravilaArhivskaFormService } from './../../../../../../form-definitions/src/lib/racun/konfiguracija/opsta-pravila-arhivska-form-service';
import { Component, OnInit } from '@angular/core';
import { ArhivskaKnjigaClient, IOpstaPravilaArhivskaDto, ResultOfOpstaPravilaArhivskaDto, UpdateOpstaPravilaArhivskaCommand, UpdateOpstaPravilaCommand } from '@kodit/core/data-api';
import { FormHelper } from '@kodit/core/form-definitions';
import { AlertService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-opsta-pravila-arhivska-form',
  templateUrl: './opsta-pravila-arhivska-form.component.html',
  styleUrls: ['./opsta-pravila-arhivska-form.component.scss']
})
export class OpstaPravilaArhivskaFormComponent implements OnInit {

  private _subs: Subscription = new Subscription();

  form: FormGroupTypeSafe<IOpstaPravilaArhivskaDto>;

  constructor(
      public _dialogRef: DynamicDialogRef,
      public _dialogConfig: DynamicDialogConfig,
      private _alertService: AlertService,
      private _client: ArhivskaKnjigaClient,
      private _fs: OpstaPravilaArhivskaFormService,
      private _formHelper: FormHelper
  ) { }

  ngOnInit(): void {
    this.form = this._fs.GetOpstaPravilaArhivskaFormGroup(
      this._dialogConfig?.data.model
    );

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this.save();
      })
    );
  }

  private save() {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    this._subs.add(
      this._client
        .updateOpstaPravilaArhivska(this.form.value as UpdateOpstaPravilaArhivskaCommand)
        .subscribe(
          (result: ResultOfOpstaPravilaArhivskaDto) => {
            if(result.succeeded){
              this._alertService.addSuccessMsg(result.messages[0]);
            }else{
              this._alertService.addWarnMsg(result.messages[0]);
            }
            this._dialogRef.close(result.data);
          },
          (error) => {
            this._subs.add(
              error.subscribe((x: string) => {
                this._alertService.addFailedMsg(x);
              })
            );
          }
        )
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
